import {
  Typography,
  FlexBox,
  SPACING,
  JoonUIColor,
  JoonColorExpanded,
} from "@joonapp/web-shared"
import { useState, useId } from "react"

import { Gradient } from "../../types"
import Tooltip from "../tooltip/Tooltip"

const IconButton = ({
  icon,
  onClick,
  tooltip,
  label,
  isFunButton,
}: {
  icon: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  tooltip?: string
  label?: string
  isFunButton?: boolean
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const id = useId()

  const hoverBackground = isFunButton
    ? Gradient.g200
    : JoonUIColor.background.xlightGray
  const hoverBorder = isFunButton
    ? `1px solid ${JoonUIColor.border.accent}`
    : `1px solid ${JoonColorExpanded.neutral300}`

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    onClick?.(e)
    setIsHovered(false)
  }

  return (
    <button onClick={handleClick} data-tooltip-id={id}>
      <FlexBox
        direction="row"
        align="center"
        gap={SPACING.space1}
        wrap={false}
        style={{ width: "fit-content" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: SPACING.space1,
            background: isHovered
              ? hoverBackground
              : JoonUIColor.background.primaryNeutral,
            minWidth: SPACING.space6,
            minHeight: SPACING.space6,
            borderRadius: SPACING.space2,
            justifyContent: "center",
            border: isHovered
              ? hoverBorder
              : `1px solid ${JoonUIColor.border.default}`,
            padding: SPACING.space1,
          }}
        >
          {icon}
        </div>
        {tooltip && (
          <Tooltip id={id}>
            <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
              {tooltip}
            </Typography>
          </Tooltip>
        )}
        {label && (
          <Typography
            variant="bodySmall"
            color={
              isHovered ? JoonUIColor.text.primary : JoonUIColor.text.secondary
            }
          >
            {label}
          </Typography>
        )}
      </FlexBox>
    </button>
  )
}

export default IconButton
